import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Ulasim.css';

function Ulasim() {
  return (
    <div className="ulasim-page">
      <Navbar />

      <header className="page-hero">
        <div className="container">
          <h2>ULAŞIM</h2>
          <p>Sivas'a Uçuş ve Yüksek Hızlı Tren Seferleri</p>
        </div>
      </header>

      <main className="content-container">

        {/* UÇAK SEFERLERİ */}
        <section className="transport-section">
          <h3><i className="fas fa-plane"></i> Sivas Uçuş Seferleri</h3>

          <div className="table-wrapper">
            <table className="transport-table">
              <thead>
                <tr>
                  <th>Havayolu</th>
                  <th>Gidiş Hattı</th>
                  <th>Uçuş No</th>
                  <th>Kalkış</th>
                  <th>Varış</th>
                  <th>Dönüş No</th>
                  <th>Kalkış</th>
                  <th>Varış</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Türk Hava Yolları (İstanbul Havalimanı)</td>
                  <td>İST - ASV</td>
                  <td>TK2658</td>
                  <td>08:10</td>
                  <td>09:45</td>
                  <td>TK2659</td>
                  <td>10:40</td>
                  <td>12:25</td>
                </tr>

                <tr>
                  <td>Türk Hava Yolları (İstanbul Havalimanı)</td>
                  <td>İST - ASV</td>
                  <td>TK2660</td>
                  <td>18:30</td>
                  <td>20:00</td>
                  <td>TK2661</td>
                  <td>20:45</td>
                  <td>22:25</td>
                </tr>

                <tr>
                  <td>AJet (Sabiha Gökçen)</td>
                  <td>SAW - ASV</td>
                  <td>VF3356</td>
                  <td>15:00</td>
                  <td>16:25</td>
                  <td>VF3357</td>
                  <td>17:10</td>
                  <td>18:50</td>
                </tr>

                <tr>
                  <td>Pegasus Airlines (Sabiha Gökçen)</td>
                  <td>SAW - ASV</td>
                  <td>PC2752</td>
                  <td>17:20</td>
                  <td>18:45</td>
                  <td>PC2753</td>
                  <td>21:05</td>
                  <td>22:40</td>
                </tr>

                <tr>
                  <td>Pegasus Airlines (İzmir Adnan Menderes)</td>
                  <td>ADB - ASV</td>
                  <td>PC3200</td>
                  <td>20:35</td>
                  <td>22:05</td>
                  <td>PC3201</td>
                  <td>22:40</td>
                  <td>00:15</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Görseldeki uçuş alt notları */}
          <div className="transport-note">
            <p>
              * Pegasus Airlines Sivas – İzmir direkt uçuşları sadece salı günleri yapılmaktadır.
            </p>
            <p>
              Planlanan uçuş saatleri değiştirilebilir. Uçuşlarınızı havayolu şirketlerinin web sitesine göre planlayınız.
            </p>
          </div>
        </section>

        {/* YHT SEFERLERİ */}
        <section className="transport-section">
          <h3><i className="fas fa-train"></i> Yüksek Hızlı Tren (YHT) Seferleri</h3>

          <div className="table-wrapper">
            <table className="transport-table tren">
              <thead>
                <tr>
                  <th>Güzergah</th>
                  <th>Kalkış</th>
                  <th>Varış</th>
                  <th>Dönüş Güzergahı</th>
                  <th>Kalkış</th>
                  <th>Varış</th>
                </tr>
              </thead>

              <tbody>
                {/* İstanbul / Söğütlüçeşme */}
                <tr>
                  <td>İstanbul (Söğütlüçeşme) → Sivas</td>
                  <td>09:00</td>
                  <td>15:50</td>
                  <td>Sivas → İstanbul (Söğütlüçeşme)</td>
                  <td>07:10</td>
                  <td>15:20</td>
                </tr>

                <tr>
                  <td>İstanbul (Söğütlüçeşme) → Sivas</td>
                  <td>13:05</td>
                  <td>21:20</td>
                  <td>Sivas → İstanbul (Söğütlüçeşme)</td>
                  <td>13:05</td>
                  <td>20:00</td>
                </tr>

                {/* Ankara Gar */}
                <tr>
                  <td>Ankara Gar → Sivas</td>
                  <td>07:00</td>
                  <td>09:40</td>
                  <td>Sivas → Ankara Gar</td>
                  <td>07:10</td>
                  <td>09:50</td>
                </tr>

                <tr>
                  <td>Ankara Gar → Sivas</td>
                  <td>13:20</td>
                  <td>15:50</td>
                  <td>Sivas → Ankara Gar</td>
                  <td>13:05</td>
                  <td>15:35</td>
                </tr>

                <tr>
                  <td>Ankara Gar → Sivas</td>
                  <td>18:40</td>
                  <td>21:20</td>
                  <td>Sivas → Ankara Gar</td>
                  <td>17:50</td>
                  <td>20:30</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Tren alt uyarısı – görseldeki */}
          <div className="transport-note">
            <p>
              Planlanan sefer saatleri değiştirilebilir. Lütfen kontrol ediniz.
            </p>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}

export default Ulasim;
